<div class="newUserContainer animateH5">
     <form [formGroup]="newUserForm" autocomplete="off">
            <div class="container userFormContainer">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <!-- <div class="card userDetailsCard" *ngIf=" userSubscription !== 1 && userSubscription "> -->
                            <div class="card userDetailsCard">
                            <div class="row">
                                <div class="col-md-12">
                                    <h4 class="userHeading border">User Registration</h4>
                                </div>
                             <!--   <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel">Company Name <i
                                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                        <input type="text" class="form-control" formControlName="company_name" name="company_name"
                                            id="companyname" placeholder="Enter company name">
                                        <span class="text-danger"
                                            *ngIf="newUserForm.controls['company_name'].invalid && newUserForm.controls['company_name'].dirty && newUserForm.hasError('required','company_name')">
                                            Company name is required.
                                        </span>
                                    </div>
                                </div>
                                 <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel">Company Location<i
                                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                        <input type="text" class="form-control" formControlName="location" name="location"
                                            id="location" placeholder="Enter location">
                                        <span class="text-danger"
                                            *ngIf="newUserForm.controls['location'].invalid && newUserForm.controls['location'].dirty && newUserForm.hasError('required','location')">
                                            Company location is required.
                                        </span>
                                    </div>
                                </div> -->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel">User Name <i
                                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                        <input type="text" class="form-control" formControlName="username" name="username"
                                            id="username" placeholder="Enter user name">
                                        <span class="text-danger"
                                            *ngIf="newUserForm.controls['username'].invalid && newUserForm.controls['username'].dirty && newUserForm.hasError('required','username')">
                                            User name is required.
                                        </span>
                                    </div>
                                </div>
                                <!-- <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel">First Name <i
                                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                        <input type="text" class="form-control" formControlName="first_name" name="first_name"
                                            id="firstname" placeholder="Enter first name">
                                        <span class="text-danger"
                                            *ngIf="newUserForm.controls['first_name'].invalid && newUserForm.controls['first_name'].dirty && newUserForm.hasError('required','first_name')">
                                            First name is required.
                                        </span>
                                    </div>
                                </div> 
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel">Last Name <i
                                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                        <input type="text" class="form-control" formControlName="last_name" name="last_name"
                                            id="lastname" placeholder="Enter last name">
                                        <span class="text-danger"
                                            *ngIf="newUserForm.controls['last_name'].invalid && newUserForm.controls['last_name'].dirty && newUserForm.hasError('required','last_name')">
                                            Last name is required.
                                        </span>
                                    </div>
                                </div>  -->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel">User Role <i
                                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                        <select type="text" class="form-select" formControlName="role" name="role"
                                            id="role">
                                            <option value="" selected hidden>--select--</option>
                                            <ng-container *ngIf="roleList.length > 0">
                                                <ng-container *ngFor="let roles of roleList">
                                                    <option *ngIf="roles.is_active" value="{{roles.name}}">{{roles.name}}</option>
                                                </ng-container>
                                            </ng-container>
                                        
                                            
                                        </select>
                                        <span class="text-danger"
                                            *ngIf="newUserForm.controls['role'].invalid && newUserForm.controls['role'].dirty && newUserForm.hasError('required','role')">
                                            User role is required.
                                        </span>
                                    </div>
                                </div>
                                <!-- <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel">User ID <i
                                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                        <input type="text" class="form-control" formControlName="userid" name="userid"
                                            id="userid" placeholder="Enter user id">
                                        <span class="text-danger"
                                        *ngIf="newUserForm.controls['userid'].invalid && newUserForm.controls['userid'].dirty && newUserForm.hasError('required','userid')">
                                            User ID is required.
                                        </span>
                                    </div>
                                </div> -->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel"
                                            [ngClass]="{ 'is-invalid': submitted && f['email'].errors }">Email <i
                                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                        <input type="email" class="form-control" formControlName="email" name="email"
                                            id="email" placeholder="example@gmail.com">
                                        <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                                            <div class="text-danger" *ngIf="f['email'].errors['required']">
                                                Email is required</div>
                                            <div class="text-danger" *ngIf="f['email'].errors['email']">Email is not Valid
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel">Emp ID <i
                                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                        <input type="text" class="form-control" formControlName="empid" name="empid"
                                            id="empid" placeholder="Enter employee id">
                                        <span class="text-danger"
                                        *ngIf="newUserForm.controls['empid'].invalid && newUserForm.controls['empid'].dirty && newUserForm.hasError('required','empid')">
                                            Emp ID is required.
                                        </span>
                                    </div>
                                </div> 
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel">Date of Join <i
                                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                        <input type="date" class="form-control" formControlName="doj" name="doj"
                                            id="doj" placeholder="Enter join date">
                                        <span class="text-danger"
                                            *ngIf="newUserForm.controls['doj'].invalid && newUserForm.controls['doj'].dirty && newUserForm.hasError('required','doj')">
                                            Date of join is required.
                                        </span>
                                    </div>
                                </div>
                         
                                  <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel"
                                            [ngClass]="{ 'is-invalid': submitted && f['password'].errors }">Password <i
                                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                        <input type="password" class="form-control" formControlName="password" name="password"
                                            id="password" placeholder="">
                                        <div *ngIf="submitted && f['password'].errors" class="invalid-feedback">
                                            <div class="text-danger" *ngIf="f['password'].errors['required']">
                                                Password is required</div>
                                            <div class="text-danger" *ngIf="f['password'].errors['pattern']">
                                                Password must be at least 8 characters, and include at least 1 number and 1 special character( _, &#64;,  or $).
                                            </div>
                                        </div>
                                    </div>
                                </div>  -->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel"
                                            [ngClass]="{ 'is-invalid': submitted && f['phone_number'].errors }">Phone Number
                                            <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                        <!-- <input type="tel" class="form-control" formControlName="phone_number"
                                            name="phone_number" id="phonenumber" placeholder="Enter phone number" ng2TelInput
                                            [ng2TelInputOptions]="{initialCountry: 'in'}" (hasError)="hasError($event)"
                                            (ng2TelOutput)="getNumber($event)" (intlTelInputObject)="telInputObject($event)"
                                            (countryChange)="onCountryChange($event)"> -->
                                             <input formControlName="phone_number" id="phonenumber" name="phonenumber"
                                        class="form-control"  #intlInput type="tel"
                                         placeholder="Enter phone number">
                                        <div *ngIf="submitted && f['phone_number'].errors" class="invalid-feedback">
                                            <div class="text-danger" *ngIf="f['phone_number'].errors['required']">
                                                Phone number is required</div>
                                            <div class="text-danger" *ngIf="f['phone_number'].errors['pattern']">Phone number
                                                is not Valid and must contain atleast 10 numbers</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 text-end">
                                    <button class="btn btn-light cancelBtn" type="button"
                                        (click)="pressCancel()">Cancel</button>
                                    <button class="btn btn-primary updateBtn" type="submit"
                                        [disabled]="newUserForm.dirty && spinner" (click)="onSubmit()">
                                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" *ngIf="spinner">
                                            <span class="sr-only">Loading...</span>
                                        </i>Save
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- <div style="display: none;" class="card userDetailsCard text-center" *ngIf="userSubscription === 1 || !userSubscription ">

                            <p class="notification-text">You are using trial account, please subscribe to add new user.</p>
                            <div class="newUserBtnClass text-center">
                                <button class="btn btn-primary updateBtn" type="submit" (click)="goSettings()">Go To
                                    Subscription</button>
                                <button class="btn btn-secondary cancelBtn" type="button" (click)="pressCancel()">Go
                                    Back</button>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </form>
</div>
